import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledProjects {
  theme: any;
}

export const StyledProjects = styled.div<IStyledProjects>`
  .main-title {
    font-size: 3em;
    ${(props) => props.theme.breakpoints.phone`
      font-size: 4em;
    `}
  }
  .mobile-main {
    padding: ${rem(`16px`)} ${rem(`16px`)} 0;
  }
  .mobile-content-welcome h2 {
    line-height: 3.5rem;
    word-break: break-all;
    ${({ theme }) => theme.breakpoints.phablet`
      word-break: initial;
    `}
  }
`;
